export default "__VITE_ASSET__Cp5eE49o__"